import { defineMessages } from 'react-intl';

import * as reportTypes from './constants';

export const pageMessages = defineMessages({
  headerMessage: {
    defaultMessage: 'Reports',
    id: 'iLXN6m',
    description: 'Insights Reports page header',
  },
});

export const labelsMessages = defineMessages({
  orders: {
    defaultMessage: 'Orders',
    id: 'zEsq69',
    description: 'Insights Reports page orders label',
  },
  products: {
    defaultMessage: 'Products',
    id: 'OOifuW',
    description: 'Insights Reports page products label',
  },
  shipments: {
    defaultMessage: 'Shipments',
    id: 'V3cBWS',
    description: 'Insights Reports page shipments label',
  },
  accounting: {
    defaultMessage: 'Accounting Reports',
    id: 'm/nksE',
    description: 'Insights Reports page accounting label',
  },
  inventory: {
    defaultMessage: 'Inventory Reports',
    id: 'HdDOt1',
    description: 'Insights Reports page inventory label',
  },
  fulfilledByShipStation: {
    defaultMessage: 'Fulfilled by ShipStation',
    id: 'fxtgNr',
    description: 'Insights Reports page fulfilled by ShipStation label',
  },
  hotkeysAndBarcodes: {
    defaultMessage: 'Hotkey & Barcode Scan Actions',
    id: 'bUvMkv',
    description: 'Insights Hotkey & Barcode Scan Actions label',
  },
  exports: {
    defaultMessage: 'Raw Data Exports',
    id: '0P7hKr',
    description: 'Insights Reports page exports label',
  },
});

export const linksMessages = defineMessages({
  [reportTypes.ORDER_DETAIL]: {
    defaultMessage: 'Order Detail',
    id: '3SnQrK',
    description: 'Insights Reports page order detail link',
  },
  [reportTypes.COUNTRY_COMPARISON]: {
    defaultMessage: 'Country Comparison',
    id: '0h6lqH',
    description: 'Insights Reports page country comparison link',
  },
  [reportTypes.BUYER_COMMENTS]: {
    defaultMessage: 'Buyer Comments',
    id: 'N9HSqu',
    description: 'Insights Reports page buyer comments link',
  },
  [reportTypes.ITEM_DEMAND_SUMMARY]: {
    defaultMessage: 'Item Demand Summary',
    id: 'Dd2TIw',
    description: 'Insights Reports page item demand summary link',
  },
  [reportTypes.PRODUCT_SALES]: {
    defaultMessage: 'Product Sales',
    id: 'gWmh78',
    description: 'Insights Reports page product sales link',
  },
  [reportTypes.RETURNED_PRODUCTS]: {
    defaultMessage: 'Returned Products',
    id: 'Yk2tl+',
    description: 'Insights Reports page returned products link',
  },
  [reportTypes.SHIPMENT_COUNT_BY_USER]: {
    defaultMessage: 'Shipment Count by User',
    id: 'NJrj7y',
    description: 'Insights Reports page shipment count by user link',
  },
  [reportTypes.SHIPMENTS_SHIPPED_ITEMS]: {
    defaultMessage: 'Shipped Items',
    id: 'VsGm+4',
    description: 'Insights Reports page shipped items link',
  },
  [reportTypes.SHIPPING_COST]: {
    defaultMessage: 'Shipping Cost',
    id: 'gNGSDk',
    description: 'Insights Reports page shipping cost link',
  },
  [reportTypes.SHIPPING_MANIFEST]: {
    defaultMessage: 'Shipping Manifest',
    id: 'RYGwh6',
    description: 'Insights Reports page shipping manifest link',
  },
  [reportTypes.BATCH_DETAIL]: {
    defaultMessage: 'Batch Detail',
    id: 'Y0i5/c',
    description: 'Insights Reports page batch detail link',
  },
  [reportTypes.ACCOUNT_BALANCE_HISTORY]: {
    defaultMessage: 'Account Balance History',
    id: '9orN1l',
    description: 'Insights Reports page account balance history link',
  },
  [reportTypes.INVENTORY_LOW_STOCK_REPORT]: {
    defaultMessage: 'Inventory Low Stock Report',
    id: 'T8sl9/',
    description: 'Insights Reports page inventory low stock report link',
  },
  [reportTypes.INVENTORY_AUDIT_REPORT]: {
    defaultMessage: 'Inventory Audit Report',
    id: 'vma3hE',
    description: 'Insights Reports page inventory audit report link',
  },
  [reportTypes.INVENTORY_OUT_OF_STOCK_SHIPMENTS]: {
    defaultMessage: 'Inventory Out Of Stock Shipments',
    id: 'qnFekg',
    description: 'Insights Reports page inventory out of stock shipments link',
  },
  [reportTypes.INVENTORY_STATUS_REPORT]: {
    defaultMessage: 'Inventory Status Report',
    id: 'vWNIJL',
    description: 'Insights Reports page inventory status report link',
  },
  [reportTypes.HOTKEYS_REFERENCE_REPORT]: {
    defaultMessage: 'Hotkey Reference Sheet',
    id: 'EsDjMr',
    description: 'Insights Reports page Hotkey Reference Report',
  },
  [reportTypes.BARCODE_SCAN_ACTION_REPORT]: {
    defaultMessage: 'Barcode Scan Action Report',
    id: 'pnOpK4',
    description: 'Insights Reports page Barcode Scan Action Report',
  },
  [reportTypes.BARCODE_SCAN_QUICK_REFERENCE_REPORT]: {
    defaultMessage: 'Barcode Scan Action Quick Reference Sheet',
    id: 'P5ZK+0',
    description: 'Insights Reports page Barcode Scan Action Quick Reference Sheet',
  },
  [reportTypes.RAW_EXPORTS_CUSTOMERS]: {
    defaultMessage: 'Customers',
    id: 'J4K/Ry',
    description: 'Insights Reports page customers link',
  },
  [reportTypes.RAW_EXPORTS_ORDERS]: {
    defaultMessage: 'Orders',
    id: '4NsVh4',
    description: 'Insights Reports page orders link',
  },
  [reportTypes.RAW_EXPORTS_SHIPPED_ORDERS]: {
    defaultMessage: 'Shipped Orders',
    id: 'Ac22+Q',
    description: 'Insights Reports page shipped orders link',
  },
  [reportTypes.RAW_EXPORTS_SHIPPED_ITEMS]: {
    defaultMessage: 'Shipped Items',
    id: 'VsGm+4',
    description: 'Insights Reports page shipped items link',
  },
  [reportTypes.RAW_EXPORTS_PRODUCT_ALIASES]: {
    defaultMessage: 'Product Aliases',
    id: 'W/osKs',
    description: 'Insights Reports page product aliases link',
  },
  [reportTypes.BILLING_REPORTS]: {
    defaultMessage: 'Billing Reports',
    id: 'hHmYXN',
    description: 'Insights Reports page billing reports link',
  },
  [reportTypes.ORDERS_BY_LOT]: {
    defaultMessage: 'Orders by Lot',
    id: 'd4yMaq',
    description: 'Insights Reports page orders by lot link',
  },
});

export const filterMessages = defineMessages({
  primaryAccount: {
    description: 'otherShippingOptions.primaryAccount',
    defaultMessage: '{accountName} (Primary)',
    id: 'VdtXLa',
  },
});

export const messages = defineMessages({
  [reportTypes.ORDER_DETAIL]: {
    defaultMessage: 'A list of orders by store with complete customer and line item details.',
    id: 'sGyB3+',
    description: 'Insights Reports page order detail message',
  },
  [reportTypes.COUNTRY_COMPARISON]: {
    defaultMessage: 'A breakdown of sales revenue & quantity of items sold by country.',
    id: 'iPyySF',
    description: 'Insights Reports page country comparison message',
  },
  [reportTypes.BUYER_COMMENTS]: {
    defaultMessage: 'A listing of all orders in a date range that contain customer notes.',
    id: 'pVeQ6H',
    description: 'Insights Reports page buyer comments message',
  },
  [reportTypes.ITEM_DEMAND_SUMMARY]: {
    defaultMessage: 'A list of products sold by order location and SKU with a count of orders, items, and total item revenue.',
    id: '5KT830',
    description: 'Insights Reports page item demand summary message',
  },
  [reportTypes.PRODUCT_SALES]: {
    defaultMessage: 'A list of products sold by store and category with a count of orders, items, and total item revenue.',
    id: 'i5Xkui',
    description: 'Insights Reports page product sales message',
  },
  [reportTypes.RETURNED_PRODUCTS]: {
    defaultMessage: 'A report of returned products, return reasons, and return shipping costs.',
    id: 'Dexa8v',
    description: 'Insights Reports page returned products message',
  },
  [reportTypes.SHIPMENT_COUNT_BY_USER]: {
    defaultMessage: 'A productivity report of shipments processed by users over time grouped by day, week, month, or year.',
    id: 'h4uxY0',
    description: 'Insights Reports page shipment count by user message',
  },
  [reportTypes.SHIPMENTS_SHIPPED_ITEMS]: {
    defaultMessage: 'A list of items shipped during a specified date range summarized by SKU.',
    id: 'vHw59r',
    description: 'Insights Reports page shipped items message',
  },
  [reportTypes.SHIPPING_COST]: {
    defaultMessage: 'A report of shipping revenue, shipping costs, and net shipping profit or loss by customer for each store.',
    id: 'nKaxUa',
    description: 'Insights Reports page shipping cost message',
  },
  [reportTypes.SHIPPING_MANIFEST]: {
    defaultMessage: 'A report of all shipping data (with tracking numbers, service class, cost, and weight) for a given day.',
    id: 'ejc2xU',
    description: 'Insights Reports page shipping manifest message',
  },
  [reportTypes.BATCH_DETAIL]: {
    defaultMessage: 'A report detailing recent batches.',
    id: 'LSdRNo',
    description: 'Insights Reports page batch detail message',
  },
  [reportTypes.ACCOUNT_BALANCE_HISTORY]: {
    defaultMessage:
      'A historical list of purchased postage for a specific carrier for a given date range, including labels purchased and balance refills.',
    id: 'NChMp3',
    description: 'Insights Reports page account balance history message',
  },
  [reportTypes.INVENTORY_LOW_STOCK_REPORT]: {
    defaultMessage: 'A list of products that have quantities at or below their reorder threshold.',
    id: 'kK1mgq',
    description: 'Insights Reports page inventory low stock report message',
  },
  [reportTypes.INVENTORY_AUDIT_REPORT]: {
    defaultMessage: 'Log detailing every time stock is changed.',
    id: 'uWhgpj',
    description: 'Insights Reports page inventory audit report message',
  },
  [reportTypes.INVENTORY_OUT_OF_STOCK_SHIPMENTS]: {
    defaultMessage: 'Log of shipments created for out of stock orders with line item details.',
    id: 'i4mUbN',
    description: 'Insights Reports page inventory out of stock shipments message',
  },
  [reportTypes.INVENTORY_STATUS_REPORT]: {
    defaultMessage:
      'Detailed information about all stock statuses of a given SKU. This report gives a snapshot of your current inventory and runs independent of a timeframe.',
    id: 'ENlUv0',
    description: 'Insights Reports page inventory status report message',
  },
  [reportTypes.HOTKEYS_REFERENCE_REPORT]: {
    defaultMessage: 'A list of available hotkeys (a.k.a. keyboard shortcuts).',
    id: 'vqAE9D',
    description: 'Insights Reports page Hotkeys reference',
  },
  [reportTypes.BARCODE_SCAN_ACTION_REPORT]: {
    defaultMessage: 'A report containing scannable barcode actions for use with a USB connected barcode scanner.',
    id: 'CZJiIc',
    description: 'Insights Reports page Barcode Scan Action report',
  },
  [reportTypes.BARCODE_SCAN_QUICK_REFERENCE_REPORT]: {
    defaultMessage: 'Choose up to ten barcode scan actions to include on a single reference sheet.',
    id: '5CGh40',
    description: 'Insights Reports page Barcode Scan Quick Reference',
  },
  [reportTypes.RAW_EXPORTS_CUSTOMERS]: {
    defaultMessage:
      'A list of customers that were acquired during a specified date range. The data is provided in a raw format which you can export to PDF or Excel.',
    id: 'tPJBRg',
    description: 'Insights Reports page customers message',
  },
  [reportTypes.RAW_EXPORTS_ORDERS]: {
    defaultMessage:
      'Need to run a report of all your shipped orders from the past month? Or maybe see from where your orders were placed. Find them here!',
    id: 'L/JM3F',
    description: 'Insights Reports page orders message',
  },
  [reportTypes.RAW_EXPORTS_SHIPPED_ORDERS]: {
    defaultMessage: 'A list of shipped orders in a raw format which you can export to PDF or Excel.',
    id: 'Icgg1j',
    description: 'Insights Reports page shipped orders message',
  },
  [reportTypes.RAW_EXPORTS_SHIPPED_ITEMS]: {
    defaultMessage: 'A list of items shipped during a specified date range summarized by SKU.',
    id: 'vHw59r',
    description: 'Insights Reports page shipped items message',
  },
  [reportTypes.RAW_EXPORTS_PRODUCT_ALIASES]: {
    defaultMessage: 'A list of aliases and their associated products provided in a raw format which you can export to PDF or Excel.',
    id: 'Jyk6YL',
    description: 'Insights Reports page product aliases message',
  },
  [reportTypes.BILLING_REPORTS]: {
    defaultMessage: 'Access billing and fulfillment reports for your ShipStation-managed orders and inventory.',
    id: 'mh0V0T',
    description: 'Insights Reports page billing reports message',
  },
  [reportTypes.ORDERS_BY_LOT]: {
    defaultMessage:
      'A list of orders by lot created within a specified date range. The data is provided in raw format and can be exported to PDF or Excel.',
    id: 'QJ7WZf',
    description: 'Insights Reports page orders by lot message',
  },
});
